import { HttpAgent } from "@ag-ui/client";
import { fetchWithAuth } from "./config";
import { getApiUrl } from "./api-config";
import { toAnalyticsUtcPeriod } from "../utils/analyticsPeriod";

export function createAnalyticsAssistant(period, threadId = crypto.randomUUID()) {
  const agent = new HttpAgent({
    threadId,
    url: getApiUrl("v1/ai-service/Assistant/ag-ui"),
    // Extend the standard AG-UI input with the backend's analytics date fields.
    fetch: (url, init) => {
      // Read the current request's dates without replacing the conversation or its thread ID.
      const { startDate, endDate } = toAnalyticsUtcPeriod(typeof period === "function" ? period() : period);
      const input = JSON.parse(init.body);
      return fetchWithAuth(url, {
        ...init,
        body: JSON.stringify({
          ...input,
          // Conversation history belongs to the server; only submit the new user turn.
          messages: input.messages.filter((message) => message.role === "user").slice(-1),
          from: startDate,
          to: endDate,
        }),
      });
    },
  });
  agent.subscribe({
    onRunStartedEvent: ({ event }) => {
      // The server may return a canonical thread ID different from the initial client UUID.
      agent.threadId = event.threadId;
    },
  });
  return agent;
}
